import { colors } from "theme"
import { PlanType } from "types"

export const planCardStyles = (
  active: boolean,
  disabled: boolean,
  plan: PlanType,
  chosen?: string | undefined,
) => {
  const { plan_type } = plan

  if (active) {
    return {
      backgroundColor: colors.persianGreen,
      color: colors.white,
    }
  } else if (disabled) {
    return {
      backgroundColor: colors.brightGray,
      color: colors.black,
    }
  } else if (chosen && chosen === plan_type) {
    return {
      backgroundColor: colors.lightPersianGreen,
      color: colors.black,
    }
  } else {
    return {
      backgroundColor: colors.white,
      color: colors.black,
    }
  }
}

export const planButtonStyles = (
  active: boolean,
  disabled: boolean,
  plan: PlanType,
  chosen?: string | undefined,
) => {
  const { plan_type } = plan

  if (active || disabled) {
    return {
      backgroundColor: colors.white,
      color: colors.black,
    }
  } else if (chosen && chosen === plan_type) {
    return {
      backgroundColor: colors.persianGreen,
      color: colors.white,
    }
  } else {
    return {
      backgroundColor: colors.persianGreen,
      color: colors.white,
    }
  }
}
